export const sortIncidentsByMostRecentUpdate = (incidents) => {
  return incidents.sort((a, b) => new Date(b.timeline.length ? b.timeline[0].time : b.timestamps.started) - new Date(a.timeline.length ? a.timeline[0].time : a.timestamps.started));
};